import React from "react";
import { Auth } from "aws-amplify";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Image,
  Flex,
  Avatar,
  Button,
} from "@chakra-ui/react";
import { useHistory } from "react-router-dom";
import { LoginButton } from "../../components/LoginButton";
import { BurgerMenuIcon } from "../../Icons/BurgerMenuIcon";
import { deleteCookieString } from "../../utils/cookie";

const UserMenu = ({ firstName, lastName, userPicture, history }) => {
  const logout = async () => {
    try {
      await Auth.signOut();
      document.cookie = deleteCookieString(`dynos_plus_session`);
      history.push("/");
      window.location.reload();
    } catch (error) {
      console.log("error signing out: ", error);
    }
  };
  return (
    <Menu>
      <MenuButton>
        <Avatar size="md" name={`${firstName} ${lastName}`} src={userPicture} />
      </MenuButton>
      <MenuList>
        <MenuItem onClick={() => history.push("/profile")}>Profile</MenuItem>
        <MenuItem onClick={logout}>Logout</MenuItem>
      </MenuList>
    </Menu>
  );
};

export const Header = ({ isAuthenticated, user, userRole, onOpen }) => {
  const history = useHistory();
  return (
    <header
      style={{ position: "sticky", top: 0, zIndex: 1, background: "#fff" }}
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
        padding="2"
        height="64px"
        borderBottom="thin solid rgba(0, 176, 255, 0.4)"
      >
        <Flex alignItems="center">
          <Button variant="ghost" onClick={onOpen} padding={0}>
            <BurgerMenuIcon />
          </Button>
          <Image
            position="relative"
            src="/images/dynos_plus_logo.svg"
            alt="dynos plus logo"
            width="150px"
          />
        </Flex>
        <Flex flexDirection="row" alignItems="center">
          {userRole !== "Student" && (
            <Button
              colorScheme="brand"
              borderRadius="20px"
              margin="0 20px 0 0"
              onClick={() => history.push("/createDyno")}
            >
              Create Dyno
            </Button>
          )}
          {isAuthenticated && user ? (
            <UserMenu
              firstName={user.firstName}
              lastName={user.lastName}
              userPicture={user.userPicture}
              history={history}
            />
          ) : (
            <LoginButton styleProps={{ variant: "outline" }} />
          )}
        </Flex>
      </Flex>
    </header>
  );
};
